import { createApp } from 'vue'
import RequestForm from '@/request_form'

document.addEventListener('DOMContentLoaded', () => {
  createApp({ components: { RequestForm } }).mount('.request')
})
